import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourQrCodeEmits = {};
export type TourQrCodeProps = {};

export default class TourQrCodeSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourQrCode = ref<OrionTour>();

	@Reactive private readonly state = { hasData: false };

	get hasData () { return this.state.hasData }

	constructor (
		private props: TourQrCodeProps,
		private emits: TourQrCodeEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();

		useTour('tourQrCode', this._tourQrCode.value);
		this.registerBusEvent('companiesLoaded', (hasData) => {
			this.state.hasData = hasData;
		});
	}

	showQrIconOnHover () {
		return {
			callback: () => {
				return new Promise((resolve) => {
					const sticker = document.getElementsByClassName('company-el')[0];
					(sticker.getElementsByClassName('orion-sticker__actions')[0] as HTMLElement).style.opacity = '1';
					setTimeout(() => {
						resolve(true);
					}, 250);
				});
			},
			label: this.$t('common.label.next'),
		};
	}

	removeHover () {
		return {
			callback: () => {
				const sticker = document.getElementsByClassName('company-el')[0];
				(sticker.getElementsByClassName('orion-sticker__actions')[0] as HTMLElement).style.opacity = '';
				return;
			},
			label: this.$t('common.label.finish'),
		};
	}

}
